module.exports = __webpack_public_path__ + "static/img/tvoc.73f10ec3.jpg";